import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Text from '../../Text';
import {
  ChartFilters,
  ChartSettings,
  ExportFormat,
  GridSetting,
} from './style';
import CustomSelect from '../../CustomSelect';
import RadioButton from '../../RadioButton';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { SAVE_PRINT_SETTINGS } from '../../../../app/redux/actions/statistics';
import TimeIntervalFilter from '../../TimeIntervalFilter';
import { EXPORT_TABS } from '.';
import theme from '../../../theme';
import Icon from '../../Icon';
import { COURSE_STATS_OPTS } from '../../../../utils/labels';

const AF_FILTERS = [
  {
    label: "Forza dell'ordine",
    value: 'ffoo',
  },
  {
    label: 'Regione',
    value: 'region',
  },
  {
    label: 'Provincia',
    value: 'province',
  },
];

const chartTypes = [
  {
    label: 'Utenti',
    key: 'users',
    filters: [
      { type: 'typology', mandatory: true },
      { type: 'time_interval', mandatory: true },
    ],
  },
  {
    label: 'Accessi',
    key: 'access',
    filters: [{ type: 'time_interval', mandatory: true }],
  },
  {
    label: 'Tutor accreditati',
    key: 'tutors',
    filters: [],
  },
  {
    label: 'Aree tematiche',
    key: 'categories',
    filters: [{ type: 'time_interval', mandatory: true }],
  },
  {
    label: 'Percorsi formativi',
    key: 'courses',
    filters: [
      { type: 'course_typology', mandatory: true },
      { type: 'time_interval', mandatory: true },
    ],
  },
  {
    label: 'Attività',
    key: 'activities',
    filters: [{ type: 'time_interval', mandatory: true }],
  },
];

const GraphicsTab = ({ isSupervisor, savePrintSettings, charts }) => {
  // Need two different states: one for tabs & one for savePrintSettings
  const [tabType, setTabType] = useState(chartTypes[0]);
  const [chartType, setChartType] = useState(chartTypes[0]);

  const onSetFormat = (f) => {
    savePrintSettings({
      key: 'format',
      value: f,
    });
  };

  const onSetFilter = ({ key, value }) => {
    savePrintSettings({
      chartType: chartType.key,
      key,
      value,
    });
  };

  useEffect(() => {
    // need to wait for savePrintSettings with correct chartType before updating with new chartType
    setTimeout(() => {
      setChartType(tabType);
    }, 300);
  }, [tabType]);

  const checkCTFields = (key = '', type, value) => {
    const fileds = charts[key];
    if (!value || value?.length === 0) return 'ko';
    // only for user & course tabs check that both are selected
    if (['users', 'courses'].includes(key)) {
      if (type === 'typology' && (!fileds?.start_date || !fileds.end_date)) {
        return 'ko';
      }
      if (type === 'time_interval' && !fileds?.filter?.length > 0) return 'ko';
    }
    return 'ok';
  };

  return (
    <>
      <Text type="h2" mb={8}>
        Grafici
      </Text>
      <Text type="b3" mb={32}>
        {isSupervisor
          ? 'Export complessivo di tutti i grafici. È possibile personalizzare le relative opzioni per ognuno di essi.'
          : 'Export complessivo dei grafico utenti contenente “Assegnazioni”, “Fruizioni” e “Completamenti”. Personalizza le impostazioni per abilitarlo.'}
      </Text>
      <GridSetting className={isSupervisor ? 'grid' : ''}>
        {isSupervisor && (
          <div>
            {chartTypes.map((ct) => (
              <div
                key={ct.key}
                className={`chart-type-card ${
                  ct.key === tabType.key ? 'active' : ''
                }`}
              >
                <Text type="b3" onClick={() => setTabType(ct)}>
                  {ct?.label}
                </Text>
                <Text type="b5" color={theme().colors.focusSelect}>
                  {charts[ct.key]?.status === 'ok' ? 'Ok' : 'Da impostare'}{' '}
                  <Icon
                    type={
                      charts[ct.key]?.status === 'ok'
                        ? 'check-circle'
                        : 'x-circle'
                    }
                    size={16}
                    stroke={theme().colors.focusSelect}
                    clickable={false}
                  />
                </Text>
              </div>
            ))}
          </div>
        )}
        <div>
          <ChartSettings>
            {chartTypes.map((ct) => (
              <ChartFilters
                key={`settings-${ct.key}`}
                className={ct.key === tabType.key ? '' : 'd-none'}
              >
                <Text type="h3" mb={8}>
                  Impostazioni "{ct.label}"
                </Text>
                <Text type="b3" mb={40}>
                  {ct.filters?.length === 0
                    ? 'Non ci sono impostazioni selezionabili per il grafico tutor.\nVerrà effettuato il download del grafico tutor con la divisione per Forza dell’Ordine'
                    : ct.filters?.length === 1
                    ? 'Seleziona il periodo temporale in base alle tue esigenze per procedere con l’export '
                    : 'Seleziona il periodo temporale e la tipologia in base alle tue esigenze per procedere con l’export'}
                </Text>
                <div className="d-flex g-48">
                  {ct.filters?.map((f, i) => {
                    switch (f?.type) {
                      case 'typology':
                        return (
                          <div key={`filter-${ct.key}-${i}`}>
                            <Text
                              type="h3"
                              className={f?.mandatory ? 'mandatory' : ''}
                              mb={16}
                            >
                              Tipologia
                            </Text>
                            <CustomSelect
                              options={AF_FILTERS}
                              isMulti
                              size="s"
                              onChange={(value) => {
                                onSetFilter({
                                  key: 'filter',
                                  value,
                                });
                                if (f?.mandatory) {
                                  savePrintSettings({
                                    chartType: chartType.key,
                                    key: 'status',
                                    value: checkCTFields(
                                      chartType.key,
                                      'typology',
                                      value
                                    ),
                                  });
                                }
                              }}
                            />
                          </div>
                        );
                      case 'course_typology':
                        return (
                          <div key={`filter-${ct.key}-${i}`}>
                            <Text
                              type="h3"
                              mb={16}
                              className={f?.mandatory ? 'mandatory' : ''}
                            >
                              Tipologia
                            </Text>
                            <CustomSelect
                              options={COURSE_STATS_OPTS}
                              size="s"
                              isMulti
                              onChange={(value) => {
                                onSetFilter({
                                  key: 'filter',
                                  value,
                                });
                                if (f?.mandatory) {
                                  savePrintSettings({
                                    chartType: chartType.key,
                                    key: 'status',
                                    value: checkCTFields(
                                      chartType.key,
                                      'typology',
                                      value
                                    ),
                                  });
                                }
                              }}
                            />
                          </div>
                        );
                      case 'time_interval':
                        return (
                          <div key={`filter-${ct.key}-${i}`}>
                            <Text
                              type="h3"
                              mb={16}
                              className={f?.mandatory ? 'mandatory' : ''}
                            >
                              Periodo
                            </Text>
                            <TimeIntervalFilter
                              id="filter-time-interval-modal-graphics-tab"
                              forceSplitMonths
                              callback={(start_date, end_date) => {
                                onSetFilter({
                                  key: 'start_date',
                                  value: start_date,
                                });
                                onSetFilter({
                                  key: 'end_date',
                                  value: end_date,
                                });
                                if (f?.mandatory) {
                                  savePrintSettings({
                                    chartType: chartType.key,
                                    key: 'status',
                                    value: checkCTFields(
                                      chartType.key,
                                      'time_interval',
                                      !!start_date
                                    ),
                                  });
                                }
                              }}
                              forcePosition="bottom right"
                              singleMonth={ct.key === 'access'}
                              maxMonthsDiff={ct.key === 'access' ? 1 : 6}
                            />
                          </div>
                        );

                      default:
                        return null;
                    }
                  })}
                </div>
              </ChartFilters>
            ))}
          </ChartSettings>
          <ExportFormat>
            <Text type="h3" mb={8} tag="legend">
              Seleziona il formato di export:
            </Text>
            <Text type="b3" mb={32}>
              La selezione del formato di export è disponibile esclusivamente
              per la sezione dedicata ai grafici.
            </Text>
            <div className="d-flex g-48">
              <RadioButton
                label=".csv"
                name="format"
                checked={charts?.format === 'csv'}
                onChange={() => onSetFormat('csv')}
              />
              <RadioButton
                label=".pdf"
                name="format"
                checked={charts?.format === 'pdf'}
                onChange={() => onSetFormat('pdf')}
              />
            </div>
          </ExportFormat>
        </div>
      </GridSetting>
    </>
  );
};

GraphicsTab.propTypes = {
  isSupervisor: PropTypes.bool,
  charts: PropTypes.object,
  savePrintSettings: PropTypes.func,
};

export default connect(
  (state) => {
    const { isSupervisor } = state.user;
    const {
      printSettings: { charts },
    } = state.statistics;
    return { isSupervisor, charts };
  },
  (dispatch) => ({
    savePrintSettings: ({ chartType, key, value }) =>
      dispatch({
        type: SAVE_PRINT_SETTINGS,
        chartType,
        key,
        value,
        tab: EXPORT_TABS.CHARTS,
      }),
  })
)(withMediaQueries(GraphicsTab));
